import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

import { DynamicContentContext } from '@scoir/college-content'

const DynamicContentProvider = ({ children }) => {
  return (
    <DynamicContentContext.Provider
      value={{
        onPlayVideo: noop,
      }}
    >
      {children}
    </DynamicContentContext.Provider>
  )
}
DynamicContentProvider.propTypes = {
  children: PropTypes.any.isRequired,
}

export default DynamicContentProvider
